import HttpClientToken from '../../services/HttpClientToken';

import { ZonaProps, defaultZona } from '../../interfaces/catalogos/ZonaInterface';

export const Zonas = () => {

    return new Promise<ZonaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Zona/', token)
            .then( ({ data } : { data : ZonaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerZona = () => {

    return new Promise<ZonaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Zona/ObtenerZonas', token)
            .then( ({ data } : { data : ZonaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarZona = ( params: ZonaProps ) => {

    return new Promise<ZonaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Zona/Actualizar', params, token)
            .then( ({ data } : { data : ZonaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultZona } );
            });

        }

    });

}

export const AgregarZona = ( params: ZonaProps ) => {

    return new Promise<ZonaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Zona/Agregar', params, token)
            .then( ({ data } : { data : ZonaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultZona } );
            });

        }

    });

}
